var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { mergeDeepRight } from "ramda";
export var getHydrateFiltersLookupsRequest = function (criteria, filters, defaultCriteria) {
    var result = Object.values(filters || {}).reduce(function (res, cur) {
        var _a;
        var lookups = (_a = cur.getLookups) === null || _a === void 0 ? void 0 : _a.call(cur, criteria, defaultCriteria);
        Object.entries(lookups !== null && lookups !== void 0 ? lookups : {}).forEach(function (_a) {
            var matchType = _a[0], matchIds = _a[1];
            if (matchIds === null || matchIds === void 0 ? void 0 : matchIds.length) {
                if (res[matchType]) {
                    res[matchType] = __spreadArray(__spreadArray([], res[matchType], true), matchIds, true);
                }
                else {
                    res[matchType] = matchIds;
                }
            }
        });
        return res;
    }, {});
    Object.keys(result).forEach(function (key) {
        var matchIds = result[key];
        result[key] = matchIds.filter(function (item, pos, self) { return self.indexOf(item) === pos; });
        if (!result[key].length) {
            delete result[key];
        }
    });
    return result;
};
var isValidLookupInfoRequest = function (request) { return !!Object.keys(request).length; };
export var useHydrateFiltersLookups = function (criteria, filters, fetchLookupInfo, initialState, defaultCriteria) {
    var _a = useState(initialState), lookupInfo = _a[0], setLookupInfo = _a[1];
    var isMounted = useRef(false);
    var updateLookupInfo = useCallback(function (request, fetchLookupInfo, options) {
        if (fetchLookupInfo && isValidLookupInfoRequest(request)) {
            fetchLookupInfo(request).then(function (lookupInfo) {
                return isMounted.current &&
                    setLookupInfo(function (cur) {
                        if (options === null || options === void 0 ? void 0 : options.merge) {
                            return mergeDeepRight(cur !== null && cur !== void 0 ? cur : {}, lookupInfo);
                        }
                        return lookupInfo;
                    });
            });
        }
    }, []);
    var rehydrateFilterLookups = useCallback(function (criteria, options) {
        var request = getHydrateFiltersLookupsRequest(criteria, filters, defaultCriteria);
        updateLookupInfo(request, fetchLookupInfo, options);
    }, [fetchLookupInfo, updateLookupInfo, filters, defaultCriteria]);
    var _b = useMemo(function () {
        var request = getHydrateFiltersLookupsRequest(criteria, filters, defaultCriteria);
        var hasLookupFilters = isValidLookupInfoRequest(request);
        return { request: request, hasLookupFilters: hasLookupFilters };
    }, [criteria, filters, defaultCriteria]), request = _b.request, hasLookupFilters = _b.hasLookupFilters;
    useEffect(function () {
        isMounted.current = true;
        updateLookupInfo(request, fetchLookupInfo);
        return function () {
            isMounted.current = false;
        };
    }, [fetchLookupInfo, updateLookupInfo, request]);
    return {
        hasLookupFilters: hasLookupFilters,
        lookupInfo: lookupInfo,
        setLookupInfo: setLookupInfo,
        rehydrateFilterLookups: rehydrateFilterLookups,
    };
};
//# sourceMappingURL=use-hydrate-filters-lookups.js.map